import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAoEcKZTbzdTTlZ0x9-gXuRnsvWVq5ZGkE",
  authDomain: "fir-demo-ca429.firebaseapp.com",
  projectId: "fir-demo-ca429",
  storageBucket: "fir-demo-ca429.firebasestorage.app",
  messagingSenderId: "177622340836",
  appId: "1:177622340836:web:9bda169d9618d2749988f1",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);